import {
  apiGet as baseGet,
  apiPost as basePost,
  apiPut as basePut,
  apiPatch as basePatch,
  apiDelete as baseDelete,
} from "../../api/utils";

export { ApiError, parseApiResponse, buildApiPayload } from "../../api/utils";

const ADMIN_API_BASE = "/admin/api/v1";

const buildUrl = (path: string): string => {
  if (path.startsWith("http")) return path;
  if (path.startsWith("/")) return `${ADMIN_API_BASE}${path}`;
  return `${ADMIN_API_BASE}/${path}`;
};

export const adminApiGet = <T>(path: string): Promise<T> =>
  baseGet<T>(buildUrl(path));

export const adminApiPost = <T>(
  path: string,
  body?: Record<string, unknown>,
): Promise<T> => basePost<T>(buildUrl(path), body);

export const adminApiPut = <T>(
  path: string,
  body?: Record<string, unknown>,
): Promise<T> => basePut<T>(buildUrl(path), body);

export const adminApiPatch = <T>(
  path: string,
  body?: Record<string, unknown>,
): Promise<T> => basePatch<T>(buildUrl(path), body);

export const adminApiDelete = (path: string): Promise<void> =>
  baseDelete(buildUrl(path));
